/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'SDCodeTableService' store object.
 * @namespace SDCodeTableServiceSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UASDCodeTableService';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static getYesNoCodetable = state => state[selectors.moduleIdentifier].getYesNoCodetable.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static isFetchingGetYesNoCodetable = state =>
    state[selectors.moduleIdentifier].isFetchingGetYesNoCodetable.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static getYesNoCodetableError = state =>
    state[selectors.moduleIdentifier].getYesNoCodetableError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static getCodetablesByTableName = state =>
    state[selectors.moduleIdentifier].getCodetablesByTableName.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static isFetchingGetCodetablesByTableName = state =>
    state[selectors.moduleIdentifier].isFetchingGetCodetablesByTableName.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static getCodetablesByTableNameError = state =>
    state[selectors.moduleIdentifier].getCodetablesByTableNameError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static getNotificationTypeCodetable = state =>
    state[selectors.moduleIdentifier].getNotificationTypeCodetable.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static isFetchingGetNotificationTypeCodetable = state =>
    state[selectors.moduleIdentifier].isFetchingGetNotificationTypeCodetable.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static getNotificationTypeCodetableError = state =>
    state[selectors.moduleIdentifier].getNotificationTypeCodetableError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static getGenderCodetable = state => state[selectors.moduleIdentifier].getGenderCodetable.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static isFetchingGetGenderCodetable = state =>
    state[selectors.moduleIdentifier].isFetchingGetGenderCodetable.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static getGenderCodetableError = state =>
    state[selectors.moduleIdentifier].getGenderCodetableError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static getStateCodetable = state => state[selectors.moduleIdentifier].getStateCodetable.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static isFetchingGetStateCodetable = state =>
    state[selectors.moduleIdentifier].isFetchingGetStateCodetable.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDCodeTableServiceSelectors
   */
  static getStateCodetableError = state =>
    state[selectors.moduleIdentifier].getStateCodetableError.payload;
}
